export let barcodeLabelContentProps = {
    key: 0,
    content_type: 0,//text or qr tag
    content: '',
    align: 0, //left, center, right
    column: 0,//first, second, third
    qr_width: 50,
    qr_top_margin: -50,
    font_bold: false
}

export let barcodeLabelProps = {
    label_size: { width: 0, height: 0, column_count: 1, font_size: 12, code_type: 0 /*0=qr code, 1=2D code */, left_margin: 0, top_margin: 0},
    preview: '',
    header_logo: '',
    footer_logo: '',
    label_contents: [JSON.parse(JSON.stringify(barcodeLabelContentProps))]
}

export let dataProps = {
    id: 0,
    sms_config: '',
    use_own_email: false,
    email_config: {
        host: '',
        port: '',
        username: '',
        password: '',
        from_name: '',
        from_email: '',
        reply_to_email: ''   
    },
    email_address_required_in_customer_form: false,
    sales_order_required_for_tailoring: false, 
    sales_inclusive_of_tax: false,
    disable_back_dated_entry: false,   
    default_gift_card_validity: 180,
    loyalty_point_ratio: 100,

    sms_api_id: '',
    sms_api_password: '',
    whatsapp_access_token: '',
    whatsapp_end_point: '',
    max_discount_allowed: 0,
    
    default_print_measurement_with_work_order: true,
    default_print_styling_with_work_order: true, 
    default_print_style_choice_image_with_work_order: false, 
    default_print_customer_profile_with_work_order: true, 
    default_print_sample_image_with_work_order: true, 
    work_order_print_horizontal: true, 
    work_order_print_qc_note: true, 
    default_print_customer_name_on_work_order: true, 
    sale_delivery_on_full_payment: true, 
    customer_is_common_to_all_stores: true,

    ip_based_restriction: false,
    ip_addresses: [],
    customer_address_required_in_customer_form: false,
    print_delivery_wo_tag_together: false,

    enable_e_payment: false,
    stripe_api_secret_key: '',
    tax_return_on_order: true,

    payment_mode: 0,
    razor_pay_api_key: '',
    razor_pay_api_secret: '',

    sale_tag_required: false,
    customer_tag_required: false,

    whats_app_number: '',
    whats_app_api_key: '',
    display_stitching_fabric_breakup: false,
    convert_invoice_on_full_payment: true,
    horizontal_measurement_form: false,
    horizontal_style_sheet: false,

    shipment_track_enable: false,
    shipment_track_api_key: '',
    can_assign_production_work_freely: false,
    customer_anniversary_dates_required: false,
    print_process_list: false,
    enable_direct_delivery: false,
    allow_negative_stock_sale: false,
    allow_stock_fabric_po: false,
    customer_photo_required: false,
    show_sales_shipping_and_handling: true,
    close_option_sale_category_browsing: false,
    sale_category_required_retail_sale: true,
    print_both_sale_number: false,
    enable_walk_in_customer: false,
    display_fabric_info_regular_sale_print: true,
    print_thermal_wo: false,
    print_tailor_name_on_wo: false,
    hide_fabric_consumption_sale_order: false,
    enable_work_order_translation: false,
    display_separate_sale_order_item_list: false,
    google_sync_code: '',
    
    print_a5_wo: false,
    print_sale_item_notes: false,
    enable_tally: false,

    wo_image_size: '400px',
    wo_fabric_image_size: '100px',
    
    fabric_sku_prefix: '',
    fabric_sku_start_number: 0,
    ready_sku_prefix: '',
    ready_sku_start_number: 0,
    stitching_sku_prefix: '',
    stitching_sku_start_number: 0,
    equipment_sku_prefix: '',
    equipment_sku_start_number: 0,
    default_customer_salutation: null,
    production_capacity_calculator: false,
    minimum_sales_payment_before_confirmation: 0,
    production_supervisor_can_edit_trial_date: false,
    production_supervisor_can_accept_trial_requests: false,
    sms_api_id: '',
    sms_api_password: '',
    sms_custom_api: '',

    customer_measurement_required: true,
    sale_print_customer_mobile_number: true,
    production_assign_work_order_rack_number: false,

    work_order_label: JSON.parse(JSON.stringify(barcodeLabelProps)),
    work_order_delivery_label: JSON.parse(JSON.stringify(barcodeLabelProps)),
    production_item_label: JSON.parse(JSON.stringify(barcodeLabelProps)),
    inventory_stock_label: JSON.parse(JSON.stringify(barcodeLabelProps)),
    inventory_sale_label: JSON.parse(JSON.stringify(barcodeLabelProps)),
    inventory_sale_ready_label: JSON.parse(JSON.stringify(barcodeLabelProps)),
    work_order_dryclean_label: JSON.parse(JSON.stringify(barcodeLabelProps)),
    work_order_washable_label: JSON.parse(JSON.stringify(barcodeLabelProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/preferences/properties.js